import { getAuthenticatedInstance } from './helpers/axios.helpers';

const authenticatedInstance = getAuthenticatedInstance();

export async function getInfos(): Promise<any> {
  // return authenticatedInstance.get('/info');
  return authenticatedInstance.get('/info');
}
